import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// Drapeaux emoji (🇫🇷/🇬🇧/🇩🇪) non fiables sous Windows (Chrome/Edge les affichent
// comme du texte "FR"/"GB"/"DE" faute de police dédiée) — on utilise de vrais SVG.
const FlagFR = (props) => (
  <svg viewBox="0 0 3 2" width="20" height="14" {...props}>
    <rect width="1" height="2" x="0" fill="#0055A4" />
    <rect width="1" height="2" x="1" fill="#FFFFFF" />
    <rect width="1" height="2" x="2" fill="#EF4135" />
  </svg>
);

const FlagGB = (props) => (
  <svg viewBox="0 0 60 36" width="20" height="14" {...props}>
    <rect width="60" height="36" fill="#00247D" />
    <path d="M0,0 L60,36 M60,0 L0,36" stroke="#FFFFFF" strokeWidth="7" />
    <path d="M0,0 L60,36 M60,0 L0,36" stroke="#CF142B" strokeWidth="3" />
    <path d="M30,0 V36 M0,18 H60" stroke="#FFFFFF" strokeWidth="11" />
    <path d="M30,0 V36 M0,18 H60" stroke="#CF142B" strokeWidth="6" />
  </svg>
);

const FlagDE = (props) => (
  <svg viewBox="0 0 3 2" width="20" height="14" {...props}>
    <rect width="3" height="2" y="0" fill="#000000" />
    <rect width="3" height="1.333" y="0.667" fill="#DD0000" />
    <rect width="3" height="0.667" y="1.333" fill="#FFCE00" />
  </svg>
);

const LANGUAGES = [
  { code: 'fr', Flag: FlagFR },
  { code: 'en', Flag: FlagGB },
  { code: 'de', Flag: FlagDE },
];

export default function LanguageSwitcher({ className = '' }) {
  const { i18n, t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const current = LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];

  return (
    <div className={`relative ${className}`} ref={ref}>
      <button
        type="button"
        onClick={() => setIsOpen((v) => !v)}
        className="flex items-center gap-1.5 px-3 h-10 rounded-full text-gray-900 hover:bg-gray-100 transition-colors text-sm font-semibold"
        aria-label={t(`language.${current.code}`)}
      >
        <current.Flag className="rounded-sm flex-shrink-0" />
        <span className="uppercase">{current.code}</span>
      </button>
      {isOpen && (
        <div className="absolute top-full right-0 mt-1 w-48 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
          {LANGUAGES.map((lang) => (
            <button
              key={lang.code}
              type="button"
              onClick={() => {
                i18n.changeLanguage(lang.code);
                setIsOpen(false);
              }}
              className={`w-full flex items-center gap-2.5 text-left px-4 py-2.5 text-sm hover:bg-gray-50 ${
                lang.code === i18n.language ? 'font-semibold text-gray-900' : 'text-gray-700'
              }`}
            >
              <lang.Flag className="rounded-sm flex-shrink-0" />
              <span className="flex flex-col leading-tight">
                <span>{t(`language.country.${lang.code}`)}</span>
                <span className="text-xs font-normal text-gray-400">{t(`language.${lang.code}`)}</span>
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
